import "./SelfHeader.scss"
import {ReactComponent as Logo} from "../../assets/self/logo.svg"
import { ReactComponent as SmallLogo } from "../../assets/logo.svg"
import { Button } from "../Button"
import { useNavigate } from "react-router-dom"

export const SelfHeader = (props: {mobile: boolean }) => {
    const navigate = useNavigate()

    return <div className={"self-header" + (props.mobile ? " mobile" : "")}>
        <Logo className="logo" onClick={() => navigate('/sizzl')}/>
        <span className="by">by</span>
        <SmallLogo className="by" onClick={() => navigate('/sizzl')}/>
        <div className="spacer"/>
        <Button text="Contact us" to="/work" color="var(--Primary-Black, #000A18)" bg="var(--Accent-Yellow, #FFEC51)" border="none"/>
    </div>
}